// home/ProblemSolutionSection.jsx
import React from 'react';
import { Bell, Clock, AlertTriangle } from 'lucide-react';
import { scrollToSection } from '../../utils/scrollToSection';

const painPoints = [
  {
    icon: Bell,
    stat: '95%',
    label: 'of alerts are noise',
    title: 'Alert Fatigue',
    body: "Your team is drowning in false positives, desensitized to real threats, and burning out on endless triage.",
    iconColor: 'text-accent-orange',
  },
  {
    icon: Clock,
    stat: '$2.4M',
    label: 'avg. annual guard labor waste',
    title: 'Labor Waste',
    body: "You're paying humans to watch empty hallways. Every minute of manual monitoring is a cost that doesn't scale.",
    iconColor: 'text-accent-orange',
  },
  {
    icon: AlertTriangle,
    stat: '100%',
    label: 'of tape reviews happen after the incident',
    title: 'Reactive Failure',
    body: "Passive surveillance doesn't stop threats. It documents them. If you're watching the tape after the incident, the system already failed.",
    iconColor: 'text-accent-orange',
  },
];

export function ProblemSolutionSection() {
  return (
    <div id="concept" className="py-16 md:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-base text-accent-orange font-semibold tracking-wide uppercase">The Problem</h2>
          <p className="mt-2 text-3xl leading-8 font-bold tracking-tight text-foreground sm:text-4xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Security shouldn't be a game of "Watch and Wait."
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {painPoints.map((point) => {
            const Icon = point.icon;
            return (
              <div key={point.title} className="bg-card rounded-lg border border-border p-8">
                <div className="flex items-center gap-3 mb-4">
                  <Icon className={`h-6 w-6 ${point.iconColor}`} />
                  <h3 className="text-lg font-semibold text-foreground">{point.title}</h3>
                </div>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-accent-orange" style={{ fontFamily: "'Space Mono', monospace" }}>
                    {point.stat}
                  </span>
                  <p className="text-sm text-muted-foreground mt-1">{point.label}</p>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {point.body}
                </p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => scrollToSection('calculator')}
            className="text-sm font-medium text-accent-orange hover:text-accent-orange/80 transition-colors"
          >
            See how much your operation is wasting &rarr; Calculate Now
          </button>
        </div>
      </div>
    </div>
  );
}
